<ng-container *ngIf="items$ | async as items">
  <ng-container *ngIf="items !== '{}'">
    <div class="exploded-view-wrapper" *ngIf="items?.explodedViewList?.length">
      <span [innerHTML]="'explodedView.goToExplodedViewPage' | cxTranslate"></span>&nbsp;
      <a
        *ngFor="let evList of items?.explodedViewList"
        [routerLink]="
          [
            './',
            {
              cxRoute: 'explodedView',
              params: { productCode: items?.code, name: items?.name, explodedViewId: evList.uid }
            }
          ] | cxUrl
        "
        >{{ businessType == 'fish' ? evList?.displayName : evList.uid }}</a
      >
      <mat-icon class="material-icons-sharp light manual-arrow">keyboard_arrow_right</mat-icon>
    </div>
    <div *ngIf="items?.sizeChart">
      <div class="size-chart-wrapper">
        <span [innerHTML]="'product.productSizeChart.label' | cxTranslate"></span>&nbsp;
        <app-generic-link [target]="'_blank'" [url]="items?.sizeChart?.media" [icon]="'manual'">{{
          items.code
        }}</app-generic-link>
      </div>
    </div>
  </ng-container>
</ng-container>
